import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from "react-router-dom"
import { fetchBolsaSolicitud } from '../actions'
import { getBolsa, getBolsaSolicitudes } from '../reducers'
import {
    Box,
    Button,
    Card, CardBody, CardFooter, CardHeader,
    Flex,
    useColorModeValue,
} from '@chakra-ui/react'
import Layout from '../layout'
import DataTable from 'react-data-table-component'


const columns = [
    { name: 'Fecha postulacion', selector: row => row.fecha, sortable: true },
    { name: 'nombre', selector: row => row.nombre, sortable: true },
    { name: 'correo', selector: row => row.correo, sortable: true },
    { name: 'telefono', selector: row => row.telefono, sortable: true },
    { name: 'Opciones', selector: row => row.opcion, sortable: false },
];

const BolsaView = () => {

    const dispatch = useDispatch()
    const [post_id] = useState(useParams("id").id)
    const post = useSelector(state => getBolsa(state, post_id))
    const solicitudes = useSelector(state => getBolsaSolicitudes(state))
    const color = useColorModeValue('white', 'gray.800')


    useEffect(() => {
        dispatch(fetchBolsaSolicitud(post_id))
    }, [])


    return (
        <Layout>

            <Flex>
                <Card w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                    <CardHeader>
                        Postulantes
                    </CardHeader>
                    <CardBody>
                        <DataTable
                            pagination
                            columns={columns}
                            defaultSortAsc={false}
                            defaultSortFieldId={1}
                            data={solicitudes.map(solicitud => {
                                let time = new Date(solicitud.created_at)
                                return {
                                    id: solicitud.id,
                                    fecha: time.toLocaleString(),
                                    nombre: solicitud.nombre,
                                    correo: solicitud.correo,
                                    telefono: solicitud.telefono,
                                    opcion: <>
                                        <Link to={`/bolsa/${solicitud.id}/view`}><Button colorScheme="blue" variant="outline">Ver postulacion</Button></Link>
                                    </>
                                }
                            })}
                        />
                    </CardBody>
                </Card>
                <Card bg={color} rounded={'md'} m={3} p={6} >
                    <CardHeader>
                        Propuesta: {post.title}

                    </CardHeader>
                    <CardBody>
                        <div className="blogContent" dangerouslySetInnerHTML={{ __html: post.description }} />
                    </CardBody>
                    <CardFooter>
                        <Link to={`/bolsa/${post.id}/edit`}><Button colorScheme="teal" variant="outline">Editar</Button></Link>
                    </CardFooter>
                </Card>
            </Flex>
        </Layout >
    )
}


export default BolsaView